import { FC, ImgHTMLAttributes } from 'react';

import * as Styled from './styles';

type Props = ImgHTMLAttributes<HTMLImageElement>;

const Image: FC<Props> = (props) => <Styled.BaseImage loading="lazy" {...props} />;

export { Image };
